﻿import config from "../config"
const baseUrl = config.base_url + "z_farm_score/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    get:{
        url:  baseUrl + "get",
        type: "get",
    },
    save:{
        url:  baseUrl + "save",
        type: "post",
    },
    getQrcode:{
        url:  baseUrl + "getQrcode",
        type: "get",
    }
}

